import React, { createContext, useContext } from 'react';
import { ListWithPagination } from '@anytag/shared-molecules';
import { SocialAccountInfluencerListSortField } from '@anytag/graphql';
import { useInfluencerParamsSearch } from '../hooks';
import { InfluencersContextReturnType } from '../schemaTypes';
import { useTwitterInfluencersList } from './hooks';
import {
  TwitterInfluencersProps,
  TwitterInfluencerProfile,
  TwitterInfluencersFilterFormValues,
  TwitterInfluencersSearchSchemaType
} from './schemaTypes';

type ContextType = InfluencersContextReturnType<
  TwitterInfluencerProfile,
  TwitterInfluencersFilterFormValues,
  SocialAccountInfluencerListSortField
>;

const Context = createContext<ContextType>({} as ContextType);

interface Props {
  value: TwitterInfluencersProps;
  children: React.ReactElement | Array<React.ReactElement>;
}

export const TwitterInfluencersProvider = ({
  children,
  value: {
    isTtcmCampaign,
    isPackagePage,
    isEngagementPage,
    getCurrentProfiles,
    getSortSelectButtonProps,
    getListSelectButtonProps
  }
}: Props) => {
  const paramsSearch = useInfluencerParamsSearch<TwitterInfluencersSearchSchemaType>();
  const { page, sort, limit, filter } = paramsSearch;
  const listProps = useTwitterInfluencersList({ page, sort, limit, filter, getCurrentProfiles });

  return (
    <Context.Provider
      value={{
        ...paramsSearch,
        ...listProps,
        isPackagePage,
        isTtcmCampaign,
        isEngagementPage,
        getListSelectButtonProps,
        sortSelectButtonProps: getSortSelectButtonProps?.(listProps.listRecords, listProps.totalRecords)
      }}
    >
      <ListWithPagination pagination={{ totalRecords: listProps.totalRecords }}>{children}</ListWithPagination>
    </Context.Provider>
  );
};

export const useTwitterInfluencersContext = () => useContext<ContextType>(Context);
